import jquery from 'jquery';
import _Singleton from '@/tools/singleton';

import options from '@/ui/ui_menu/default-selectors.json';
import defaultSettings from '@/ui/ui_menu/default-settings.json';

/**
 * @class
 * @private
 *
 * @description
 * DOM + Menu
 */
var MenuDOM = function() {
  var self = this;

  document.addEventListener('DOMContentLoaded', function() {
    self._init();
  });
};

/**
 * Инициализация
 * @method
 * @private
 */
MenuDOM.prototype._init = function() {
  var self = this;
  self.options = options;
  self.defaultSettings = defaultSettings;

  self.currentPageUrl = new URL(window.location.href);

  self._addClassForCurrentPage();
};

/**
 * Обновление
 * @method
 * @private
 */
MenuDOM.prototype.update = function() {
  var self = this;
  self._addClassForCurrentPage();
};

/**
 * Установка доп. классов для активного пункта меню
 * @method
 * @private
 */
MenuDOM.prototype._addClassForCurrentPage = function() {
  var self = this;

  jquery(self.options.menu.attr).not(self.options.isInited.attr).each(function() {
    var menu_node = jquery(this);
    menu_node.attr(self.options.isInited.value, true);

    menu_node.find(self.options.menuLink.attr).each(function() {
      var menu_link_node = jquery(this);

      if (self.currentPageUrl.pathname === menu_link_node.data(self.options.menuLink.data)) {
        menu_link_node.addClass(self.defaultSettings.classes.currentLink);
        menu_link_node.parents(self.options.menuItem.attr).addClass(self.defaultSettings.classes.currentLink);
      }
    });
  });
};

export default _Singleton(MenuDOM).getInstance();
